import { StreamingSpinner } from 'trueye-component-library'
import { SpinnerContainer } from './styles'

interface LoadingSpinnerProps {
  message?: string
}

const AppLoadingSpinner = ({ message = 'Loading...' }: LoadingSpinnerProps) => {
  return (
    <SpinnerContainer>
      <StreamingSpinner message={message} />
    </SpinnerContainer>
  )
}

export default AppLoadingSpinner
